import type { RouteProp } from '@react-navigation/core';
import type { StackNavigationProp } from '@react-navigation/stack';

import {
  BooleanParam,
  CoreRootStackParamList,
  DeeplinkConfigShape,
  NumberParam,
} from '@oui/app-core/src/types/navigation';

export type WordPairingStackParamList = {
  WordPairingIndex: {};
  WordPairingShow: { practiceID: string };
  WordPairingNew: {
    round: NumberParam;
    break: BooleanParam;
    practiceID?: string;
  };
};

export const WORD_PAIRING_DEEPLINK_CONFIG = {
  WordPairingIndex: 'word-pairing',
  WordPairingNew: 'word-pairing/new',
  WordPairingShow: 'word-pairing/:practiceID',
} as const satisfies DeeplinkConfigShape<keyof WordPairingStackParamList>;

type FullStackParamList = WordPairingStackParamList & CoreRootStackParamList;

export type StackScreenProps<
  T extends keyof WordPairingStackParamList,
  Other extends object = {},
> = {
  navigation: StackNavigationProp<FullStackParamList, T>;
  route: RouteProp<FullStackParamList, T>;
} & Other;

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace ReactNavigation {
    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    interface RootParamList extends FullStackParamList {}
  }
}
